<template>
  <div class="layout flex row">
    <audio hidden ref="audio_new_message">
      <source src="../assets/audio/audio_message_soft.mp3" type="audio/mpeg" />
    </audio>
    <audio hidden ref="audio_new_ticket">
      <source src="../assets/audio/sound_new_ticket_soft.mp3" type="audio/mpeg" />
    </audio>
    <div class="sidebar">
      <div class="header flex row justify-center">
        <q-list>
          <q-item clickable class="q-mb-md q-pt-md" :to="{ name: 'home' }">
            <q-item-section>
              <img
                src="@/assets/images/logo-cosmos.svg"
                width="32"
                height="32"
              />
            </q-item-section>
          </q-item>
        </q-list>
      </div>
      <div class="body">
        <q-list>
          <div
            v-for="(item, index) in store.state.menu"
            :key="item.id"
            class="flex row justify-center body-menu-item"
          >
            <q-item clickable @click="handleRedirect(item)">
              <q-item-section>
                <img
                  src="@/assets/images/dash-bar-icon.svg"
                  v-if="item.icone === 'o_finance'"
                />
                <q-icon :name="item.icone" color="grey-5" size="1.5rem" v-else>
                  <q-badge
                    floating
                    rounded
                    color="red"
                    style="min-height: 8px"
                    v-if="
                      item.modulo === 'chat' && notifyNewAttendaceOrMenssageChat
                    "
                  />
                  <q-badge
                    floating
                    rounded
                    color="red"
                    style="min-height: 8px"
                    v-if="
                      item.modulo === 'ticket' &&
                      notifyNewAttendaceOrMenssageTicket
                    "
                  />
                </q-icon>
              </q-item-section>
              <q-tooltip
                class="text-body"
                anchor="center left"
                self="center right"
                :offset="[2, 2]"
              >
                {{ item.label_menu }}
              </q-tooltip>
            </q-item>

            <!-- <q-item v-if="(index + 1) == store.state.menu.length" @click="accessPhoneView" clickable >
              <q-item-section>
                <q-icon name="phone" color="grey-5" size="1.5rem"></q-icon>
              </q-item-section>
              <q-tooltip class="text-body" anchor="center left" self="center right" :offset="[2, 2]">
                Telefone
              </q-tooltip>
            </q-item> -->
          </div>
          <div
            v-if="[1, 2, 3].includes(Number(store.state.userData.id_papel))"
            class="flex row justify-center body-menu-item"
          >
            <q-item
              clickable
              :active="route.name === 'sla-dashboard'"
              @click="router.push({ name: 'sla-dashboard' })"
            >
              <q-item-section>
                <q-icon name="query_stats" color="grey-5" size="1.5rem" />
              </q-item-section>
              <q-tooltip
                class="text-body"
                anchor="center left"
                self="center right"
                :offset="[2, 2]"
              >
                Painel de SLA
              </q-tooltip>
            </q-item>
          </div>
        </q-list>
      </div>
      <div class="footer">
        <div class="footer-menu-item flex row justify-center">
          <div class="flex row justify-center items-center full-width">
            <q-btn flat unelevated round dense class="q-pa-none avatar-status-btn" data-tour="user-menu-btn">
                <q-img
                  src="@/assets/images/person-avatar.svg"
                  width="1.8rem"
                  :style="`border: 2px solid ${color_avatar_status_corrent}; border-radius: 22px`"
                />

                <q-tooltip
                  v-if="pauseMotive"
                  class="text-body"
                  style="
                    background: yellow;
                    border-radius: 0px 5px 5px 0px;
                    color: black;
                  "
                  anchor="center left"
                  self="center right"
                  :offset="[12, 2]"
                >
                  {{ pauseMotive }}
                </q-tooltip>
                <q-menu
                  class="card-list-status"
                  anchor="top right"
                  self="top left"
                  :offset="[12, 0]"
                >
                  <q-list class="agent-menu-list" data-tour="user-status-menu">
                    <div class="agent-menu-name">{{ store.state.userData.nome }}</div>
                    <q-separator class="agent-menu-separator" />

                    <q-item class="agent-menu-item flex row justify-between" clickable>
                      <label>Disponível</label>
                      <q-badge rounded color="green" class="agent-menu-dot" />
                      <q-menu anchor="top left" self="top right" fit>
                        <q-list>
                          <div
                            v-for="item in availableStatusOptions"
                            :key="item.id"
                          >
                            <q-item
                              clickable
                              v-close-popup
                              @click="changeStatus(item.id, 'green')"
                            >
                              <q-item-section>
                                <q-item-label>{{
                                  item.descricao
                                }}</q-item-label>
                              </q-item-section>
                            </q-item>
                          </div>
                        </q-list>
                      </q-menu>
                    </q-item>

                    <q-item class="agent-menu-item flex row justify-between" clickable>
                      <label>Pausa</label>
                      <q-badge rounded color="amber" class="agent-menu-dot" />
                      <q-menu anchor="top left" self="top right" fit>
                        <q-list>
                          <div
                            v-for="item in listMotivePause"
                            :key="item.id_motivo_pausa_status_atividade_usuario"
                          >
                            <q-item
                              clickable
                              v-close-popup
                              @click="
                                changeStatus(
                                  2,
                                  'yellow',
                                  item.id_motivo_pausa_status_atividade_usuario
                                )
                              "
                            >
                              <q-item-section>
                                <q-item-label>{{
                                  item.descricao
                                }}</q-item-label>
                              </q-item-section>
                            </q-item>
                          </div>
                        </q-list>
                      </q-menu>
                    </q-item>
                    <q-item
                      class="agent-menu-item flex row justify-between"
                      @click="changeStatus(3, 'red')"
                      clickable
                      v-close-popup
                    >
                      <label>Indisponível</label>
                      <q-badge rounded color="red" class="agent-menu-dot" />
                    </q-item>

                    <q-separator class="agent-menu-separator" />

                    <q-item class="agent-menu-item" clickable v-close-popup @click="logout">
                      <q-item-section avatar>
                        <q-icon name="o_logout" size="1.1rem" color="grey-6" />
                      </q-item-section>
                      <q-item-section>Sair</q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
              </q-btn>
          </div>
        </div>
        <q-dialog v-model="alerta">
          <q-card style="width: 70vh" class="q-pb-sm">
            <q-card-section>
              <div class="text-h6">Alterar a senha</div>
            </q-card-section>

            <q-card-section>
              <q-input
                outlined
                v-model="oldPassword"
                label="senha antiga"
                :type="isPassword ? 'password' : 'text'"
                class="q-pb-md"
              >
                <template v-slot:append>
                  <q-icon
                    :name="isPassword ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPassword = !isPassword"
                  />
                </template>
              </q-input>
              <q-input
                outlined
                v-model="newPassword"
                label="nova senha"
                :type="isNewPassword ? 'password' : 'text'"
                class="q-pb-md"
                @focus="verifyPassword"
              >
                <template v-slot:append>
                  <q-icon
                    :name="isNewPassword ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isNewPassword = !isNewPassword"
                  />
                </template>
              </q-input>
              <q-input
                outlined
                v-model="passwordVerification"
                label="repita a senha"
                :rules="rules_empty"
                :type="isPasswordVerification ? 'password' : 'text'"
                class="q-pb-md"
              >
                <template v-slot:append>
                  <q-icon
                    :name="
                      isPasswordVerification ? 'visibility_off' : 'visibility'
                    "
                    class="cursor-pointer"
                    @click="isPasswordVerification = !isPasswordVerification"
                  />
                </template>
              </q-input>
            </q-card-section>

            <q-card-actions
              v-if="newPassword == passwordVerification && oldPassword != ''"
              align="right"
            >
              <q-btn
                flat
                label="Atualizar"
                color="primary"
                @click="updatePassword"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </div>
    </div>

    <div class="internal-chat shadow-3 chat-interno" v-show="showInternalChat">
      <div class="col-12 row flex q-pr-sm header shadow-1">
        <div class="col-11 q-pl-md row flex justify-center items-center">
          <label class="text-white">Chat interno</label>
        </div>

        <div class="col-1 row flex justify-center">
          <q-btn
            flat
            round
            color="white"
            icon="close"
            @click="showInternalChat = !showInternalChat"
          />
        </div>
      </div>

      <div class="col-12">
        <SideInternalChat @isnewmessage="warninIcon"> </SideInternalChat>
      </div>
    </div>
    <q-btn
      size="1rem"
      v-show="!showInternalChat"
      round
      icon="o_help"
      class="q-ml-md btn-internal-chat"
      data-tour="help-btn"
    >
      <div v-show="warningSign">
        <q-badge class="btn-internal-notification" rounded color="orange" />
      </div>

      <q-menu
        class="support-menu"
        anchor="top right"
        self="bottom right"
        :offset="[0, 12]"
      >
        <q-list class="support-menu-list" data-tour="support-menu-list">
          <div class="support-menu-section-title">Suporte</div>

          <q-item
            class="support-menu-item"
            clickable
            v-close-popup
            @click="showInternalChat = true"
          >
            <q-item-section avatar>
              <q-icon name="o_chat" size="1.1rem" color="grey-4" />
            </q-item-section>
            <q-item-section>Chat interno</q-item-section>
            <q-item-section side v-if="warningSign">
              <q-badge rounded color="orange" />
            </q-item-section>
          </q-item>

          <q-item class="support-menu-item" clickable v-close-popup @click="showHelp">
            <q-item-section avatar>
              <q-icon name="o_help_outline" size="1.1rem" color="grey-4" />
            </q-item-section>
            <q-item-section>Ajuda</q-item-section>
          </q-item>

          <!--
          <q-item
            class="support-menu-item"
            clickable
            v-close-popup
            @click="showFeedbackDialog = true"
          >
            <q-item-section avatar>
              <q-icon name="o_feedback" size="1.1rem" color="grey-4" />
            </q-item-section>
            <q-item-section>Enviar feedback</q-item-section>
          </q-item>
          -->

          <q-item class="support-menu-item" data-tour="dark-mode-toggle">
            <q-item-section avatar>
              <q-icon
                :name="darkModeEnabled ? 'dark_mode' : 'light_mode'"
                size="1.1rem"
                color="grey-4"
              />
            </q-item-section>
            <q-item-section>Modo escuro</q-item-section>
            <q-item-section side>
              <q-toggle
                v-model="darkModeEnabled"
                color="deep-purple-4"
                @update:model-value="toggleDarkMode"
              />
            </q-item-section>
          </q-item>

          <q-item class="support-menu-item">
            <q-item-section avatar>
              <q-icon
                :name="
                  arrivalNotificationsEnabled
                    ? 'o_notifications_active'
                    : 'o_notifications_off'
                "
                size="1.1rem"
                color="grey-4"
              />
            </q-item-section>
            <q-item-section>Notificações de mensagens</q-item-section>
            <q-item-section side>
              <q-toggle
                v-model="arrivalNotificationsEnabled"
                color="deep-purple-4"
                @update:model-value="toggleArrivalNotifications"
              />
            </q-item-section>
          </q-item>

          <q-item class="support-menu-item" data-tour="tour-toggle">
            <q-item-section avatar>
              <q-icon name="o_flag" size="1.1rem" color="grey-4" />
            </q-item-section>
            <q-item-section>Tour de novidades</q-item-section>
            <q-item-section side>
              <q-toggle
                :model-value="!tourVisto"
                color="deep-purple-4"
                @update:model-value="setTourEnabled"
              />
            </q-item-section>
          </q-item>
        </q-list>
      </q-menu>
    </q-btn>

    <div class="content flex row">
      <!-- <PhonePage :config="config" @show_call="accessPhoneView"/> -->

      <router-view v-show="!phoneView" v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </div>

    <FeedbackDialog v-model="showFeedbackDialog" />
  </div>
</template>
<script setup>
import SideInternalChat from "@/components/chat/SideInternalChat.vue";
import FeedbackDialog from "@/components/common/FeedbackDialog.vue";
import ChatProvider from "@/provider/ChatProvider";
import WidgetProvider from "@/provider/WidgetProvider";
import SettingServices from "@/services/SettingServices";
import UserServices from "@/services/UserServices";
import { useQuasar } from "quasar";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { STATUS_MAPPER } from "@/utils/constants/phoneCall/status";
import { useOnboardingTour } from "@/composables/useOnboardingTour";

let phoneView = ref(false);

let config = ref({ 
  out_screen: true,
});

let alerta = ref(false);
let rules_empty = [
  (val) =>
    (val == newPassword.value && val.length > 1) ||
    "As senhas tem que ser iguais",
];
const $q = useQuasar();
const store = useStore();
const { startTour, tourVisto, setTourEnabled } = useOnboardingTour();
const audio_new_message = ref();
const audio_new_ticket = ref();

const _chatProvider = new ChatProvider();

const _widgetProvider = new WidgetProvider();
const _userServices = new UserServices();
let _settingServices = new SettingServices("reason-state-pause");
_chatProvider.start();
_widgetProvider.start();
let pauseMotive = ref("");
let notifyNewAttendaceOrMenssageChat = computed(
  () => store.state.notifyNewAttendaceOrMenssageChat
);
let notifyNewAttendaceOrMenssageTicket = computed(
  () => store.state.notifyNewTickt
);
let showInternalChat = ref(false);
let listMotivePause = ref([]);
let warningSign = ref(false);
let oldPassword = ref("");
let newPassword = ref("");
let passwordVerification = ref("");
let isPassword = ref(true);
let isPasswordVerification = ref(true);
let isNewPassword = ref(true);
let color_avatar_status_corrent = ref("");

let hasWaitList = ref(false);
let pauseReason = ref("");
let newStatusAfterCall = ref("");

let availableStatusOptions = [
  {
    descricao: "Chat",
    id: 1,
  },
  {
    descricao: "Voz",
    id: 4,
  },
  {
    descricao: "Chat/Voz",
    id: 5,
  },
];

const colorMapper = {
  1: "green",
  2: "yellow",
  3: "red",
  4: "green",
  5: "green",
};

const router = useRouter();
const route = useRoute();

function accessPhoneView() {
  phoneView.value = true;
  config.value.out_screen = false;
}

function unAccessPhoneView() {
  phoneView.value = false;
  config.value.out_screen = true;
}

function openModal() {
  alerta.value = true;
}

let darkModeEnabled = ref(localStorage.getItem("dark_mode") === "true");
let showFeedbackDialog = ref(false);

function toggleDarkMode(value) {
  $q.dark.set(value);
  localStorage.setItem("dark_mode", value ? "true" : "false");
}

let arrivalNotificationsEnabled = ref(
  localStorage.getItem("arrival_notifications") !== "false"
);

function toggleArrivalNotifications(value) {
  localStorage.setItem("arrival_notifications", value ? "true" : "false");
}

function showHelp() {
  window.open(
    "https://wtf.cosmos.inf.br/widget-externo?company=1&widget=1&id=MviodMdaIJH648AoVdAOmdUhoP",
    "_blank"
  );
}

function _findPauseMotive(motivePause) {
  let motiveFound = listMotivePause.value.find(
    (motive) => motive.id_motivo_pausa_status_atividade_usuario == motivePause
  );
  pauseMotive.value = motiveFound.descricao;
  store.commit("setPauseMotive", {
    title: motiveFound.descricao,
    created_at: new Date(),
  });
}

function verifyPassword() {
  if (oldPassword.value != passwordVerification.value) {
  }
}

async function updatePassword() {
  $q.loading.show();
  let passwords = {
    newPassword: newPassword.value,
    oldPassword: oldPassword.value,
  };
  await _userServices
    .updatePassword(store.state.userData.id_usuario, passwords)
    .then((response) => {
      if (response) {
        $q.notify({
          message: `Senha alterada com sucesso.`,
          color: "green-8",
          position: "top",
        });
      } else {
        $q.notify({
          message: `Não foi possível alterar a senha.`,
          color: "red-8",
          position: "top",
        });
      }
      $q.loading.hide();
    });
}

const waitToChangeStatus = (newStatus, motivePause) => {
  const message =
    newStatus === 2
      ? "Seu status será alterado para pausa após o término do pós-atendimento."
      : "Seu status será alterado para indisponível após o término do pós-atendimento.";
  $q.notify({
    message: message,
    color: "orange-8",
    position: "top",
  });
  hasWaitList.value = true;
  pauseReason.value = motivePause;
  newStatusAfterCall.value = newStatus;
  return;
};

async function changeStatus(code_status, color_status, motivePause = 0) {
  if (
    (Number(code_status) === 3 || Number(code_status) === 2) &&
    localStorage.getItem("currentStatus") == STATUS_MAPPER.EM_ATENDIMENTO
  ) {
    return waitToChangeStatus(Number(code_status), motivePause);
  }

  $q.loading.show();

  try {
      const response = await _userServices.changeStatus(code_status, motivePause);

    if (response?.databaseSuccess) {
      store.commit("setStatus", code_status);
      motivePause != 0
        ? _findPauseMotive(motivePause)
        : (pauseMotive.value = "");

      color_avatar_status_corrent.value = color_status;

      if (!response.agentSuccess && store.state.userData.habilita_dac) {
        $q.notify({
          message: `⚠️ Status alterado localmente, mas houve erro na comunicação com o Asterisk!`,
          color: "orange-8",
          position: "top",
        });
      } else {
        $q.notify({
          message: `Status alterado com sucesso.`,
          color: "green-8",
          position: "top",
        });
      }
    } else {
      $q.notify({
        message: `❌ Não foi possível alterar o status.`,
        color: "red-8",
        position: "top",
      });
    }
  } catch (err) {
    $q.notify({
      message: `Erro ao tentar mudar o status: ${err.message || err}`,
      color: "red-8",
      position: "top",
    });
  } finally {
    $q.loading.hide();
  }
}

function _getLogStatus() {
  $q.loading.show();
  _userServices
    .getLogStatus(store.state.userData.id_usuario)
    .then((response) => {
      if (response) {
        switch (response[0].id_status_atividade_usuario) {
          case 1:
            store.commit("setStatus", 1);
            color_avatar_status_corrent.value = "green";
            pauseMotive.value = "";
            break;
          case 2:
            store.commit("setStatus", 2);
            color_avatar_status_corrent.value = "yellow";
            pauseMotive.value = response[0].descricao;
            store.commit("setPauseMotive", {
              title: response[0].descricao,
              created_at: response[0].data_atividade,
            });
            break;
          case 3:
            store.commit("setStatus", 3);
            color_avatar_status_corrent.value = "red";
            pauseMotive.value = "";
            break;
          case 4:
            store.commit("setStatus", 4);
            color_avatar_status_corrent.value = "green";
            pauseMotive.value = "";
          case 5:
            store.commit("setStatus", 5);
            color_avatar_status_corrent.value = "green";
            pauseMotive.value = "";
            break;
          default:
            color_avatar_status_corrent.value = "red";
        }
      } else {
        store.commit("setStatus", 3);
        color_avatar_status_corrent.value = "red";
        pauseMotive.value = "";
      }
      $q.loading.hide();
    });
}

function _getMotivePause() {
  $q.loading.show();
  _settingServices
    .getAllActive(store.state.userData.id_empresa)
    .then((response) => {
      listMotivePause.value = response;
      $q.loading.hide();
    });
}

function warninIcon(isNewMessage) {
  warningSign.value = isNewMessage;
}

async function logout() {
  //Status 3 corresponde a inativo
  await changeStatus(3, "red");
  $q.loading.show();
  _userServices.Logout().then((response) => {
    if (response) {
      $q.loading.hide();
      localStorage.clear();
      store.dispatch("timer/stopTimer");
      router.push({ name: "/" });
      _chatProvider.disconnect();
    } else {
      $q.loading.hide();
      $q.notify({
        message: `Não foi possível fazer o logout, tente novamente mais tarde.`,
        color: "red-8",
        position: "top",
      });
    }
  });
}

function _getMessagesOfCustomerChat() {
  _chatProvider.connection.on("ReceiveMessage", (conversationId, message) => {
    if (message.cliente) {
      if (route.name !== "chat") {
        store.commit("setNotifyNewAttendaceOrMenssageChat", true);
      }
      _audioNewMessage();
      // Payload real é MessageAttendance (backend): só tem "nome" (nome do
      // contato via join) e "mensagem" — não existe nome_cliente/protocolo
      // nesse objeto. Usar os campos certos, senão cai sempre no fallback
      // genérico "Nova notificação" e o toast fica sem informação útil.
      _showArrivalToast({
        sender: message.nome,
        text: message.mensagem,
        icon: "chat_bubble",
      });
    }
  });
}

function _newAttendancesChat() {
  _chatProvider.connection.on(
    "NotifyNewAttendances",
    (conversationId, attendance) => {
      if (route.name !== "chat") {
        store.commit("setNotifyNewAttendaceOrMenssageChat", true);
      }
      _audioNewMessage();
      // Payload real é Queue (backend): tem nome_cliente/protocolo, mas não
      // tem texto de mensagem — usar nome do canal como contexto.
      _showArrivalToast({
        sender: attendance.nome_cliente,
        protocolo: attendance.protocolo,
        text: attendance.nome_canal
          ? `Nova conversa via ${attendance.nome_canal}`
          : "Nova conversa recebida",
        icon: "chat_bubble",
      });
    }
  );
}

function _newAttendancesTickets() {
  _chatProvider.connection.on("NotifyNewTickets", (ticket) => {
    store.commit("setNotifyNewTicket", true);
    _audioNewTicket();
    _showArrivalToast({
      sender: ticket.nome_cliente,
      protocolo: ticket.protocolo,
      text: ticket.assunto,
      icon: "o_confirmation_number",
    });
  });
}

function _slaAlerts() {
  _chatProvider.connection.on(
    "NotifyTicketSla",
    (ticketId, protocol, percentage, title, text, permanent, playSound) => {
      if (!arrivalNotificationsEnabled.value) return;
      if (playSound) _audioNewTicket();
      _showArrivalToast({
        sender: title || `Alerta de SLA · ${percentage}%`,
        protocolo: protocol,
        text,
        icon: "schedule",
        timeout: permanent ? 0 : 4500,
        closeBtn: permanent ? "Fechar" : undefined,
        extraClass: "sla-toast-notify",
      });
    }
  );
}

function _truncateText(text, maxLength = 70) {
  if (!text) return "";
  const plain = String(text)
    .replace(/<[^>]*>/g, "")
    .replace(/(?:\r\n|\r|\n)/g, " ")
    .trim();

  return plain.length > maxLength ? plain.slice(0, maxLength).trim() + "…" : plain;
}

function _showArrivalToast({
  sender,
  protocolo,
  text,
  icon,
  timeout = 4500,
  maxTextLength = 70,
  closeBtn,
  extraClass,
}) {
  if (!arrivalNotificationsEnabled.value) return;

  const senderLabel =
    sender || (protocolo ? `Protocolo ${protocolo}` : "Nova notificação");

  $q.notify({
    message: senderLabel,
    caption: _truncateText(text, maxTextLength) || "Nova mensagem recebida",
    icon: icon || "notifications",
    position: "bottom-right",
    textColor: "white",
    timeout,
    closeBtn,
    classes: extraClass ? `arrival-toast-notify ${extraClass}` : "arrival-toast-notify",
  });
}

function handleAsteriskUnreachable() {
  _chatProvider.connection.on("AsteriskIsUnreachable", (ramal) => {
    if (store.state.userData.id_status_atividade_usuario === 5) {
      changeStatus(1, "green");
      return;
    } else {
      changeStatus(3, "red");
    }

    $q.dialog({
      title: "Atenção",
      message:
        "A conexão com o servidor de telefonia foi perdida. Seu status foi alterado.",
      persistent: true,
    }).onOk(() => {});
  });
}

function _audioNewMessage() {
  audio_new_message.value.play();
}

function _audioNewTicket() {
  audio_new_ticket.value.play();
}

function addListeningToPhoneCall() {
  _chatProvider.connection.on(
    "NotifyAboutNewPhoneCall",
    (dacId, callerNumber, voiceProtocol, attendanceStartingTime) => {
      let phoneAttendanceData = storeVoiceAttendanceData(
        callerNumber,
        attendanceStartingTime,
        voiceProtocol
      );

      // if (store.state.userData.id_status_atividade_usuario != "3") {
      //   changeStatus(3, "red");
      // }

      store.commit("setPhoneAttendanceData", phoneAttendanceData);
      let phoneWindowPopUp = router.resolve({
        name: "call",
        params: { id: dacId },
        props: true,
      });

      const newWindow = window.open(phoneWindowPopUp.href);
      if (newWindow) {
        newWindow.focus();
      } else {
        alert(
          "Pop-up bloqueado pelo navegador! Por favor, permita pop-ups para este site."
        );
      }
    }
  );
}

function storeVoiceAttendanceData(
  callerNumber,
  attendanceStartingTime,
  voiceProtocol
) {
  let formatedInitialTime = new Date(attendanceStartingTime);

  let inMilliseconds = formatedInitialTime.getTime();

  let phoneAttendanceData = {
    callerNumber: callerNumber,
    initialTime: inMilliseconds,
    voiceProtocol: voiceProtocol,
  };

  return phoneAttendanceData;
}

function redirectPhoneModule(label) {
  const isDashboard = label.toLowerCase() === "dashboard";
  const routeName = isDashboard ? "phone-dashboard" : "phone";
  const phoneRoute = isDashboard ? "dashboard" : "voice";

  router.push({ name: routeName });
  store.commit("setPhoneRoute", phoneRoute);
}

function handleRedirect(item) {
  unAccessPhoneView();

  const { modulo, label_menu } = item;

  if (modulo === "phone") {
    redirectPhoneModule(label_menu);
    return;
  }

  return router.push({ name: modulo });
}

async function logoutOnRefresh() {
  const codeStatus = 3;
  const statusUrl = `${process.env.VUE_APP_BASE_URL}/v1/user/${codeStatus}/change-status?motivePause=0`;
  const logoutUrl = `${process.env.VUE_APP_BASE_URL}/v1/user/logout`;
  const headers = {
    Authorization: `Bearer ${localStorage.getItem("token_plataforma_digital")}`,
    "Content-Type": "application/json",
    tenant: "stag",
  };
  await fetch(statusUrl, {
    method: "POST",
    headers: headers,
    keepalive: true,
  }).catch((err) => console.error("Falha ao enviar logoff:", err));
  localStorage.clear();
  store.dispatch("timer/stopTimer");
  router.push({ name: "/" });
  _chatProvider.disconnect();
  await fetch(logoutUrl, {
    method: "POST",
    headers: headers,
    keepalive: true,
  }).catch((err) => console.error("Falha ao enviar logoff:", err));
}

function handleEndAttendance(wrapUpTime) {
  store.commit("setPhoneAttendanceData", {});
  store.dispatch("timer/stopTimer");

  localStorage.setItem("endAttendance", wrapUpTime);

  $q.notify({
    message: "Atendimento encerrado pelo sistema.",
    color: "info",
    position: "top",
  });
}

const listenStatusChange = (newStatus) => {
  // store.commit('setStatus', parseInt(newStatus));
  changeStatus(parseInt(newStatus), colorMapper[parseInt(newStatus)] || "red");
  localStorage.removeItem("newStatus");
};

function handlePageClose(event) {
  if (!event.persisted) {
    let isReload = false;
    
    try {
      const navigationEntry = performance.getEntriesByType('navigation')[0];
      if (navigationEntry) {
        isReload = navigationEntry.type === 'reload';
      } else {
        if (performance.navigation) {
          isReload = performance.navigation.type === 1;
        }
      }
    } catch (e) {
      isReload = false;
    }
    
    if (!isReload) {
      logoutOnRefresh();
    }
  }
}


onMounted(() => {
  $q.dark.set(darkModeEnabled.value);
  _getLogStatus();
  _getMotivePause();
  _getMessagesOfCustomerChat();
  _newAttendancesChat();
  _newAttendancesTickets();
  _slaAlerts();
  handleAsteriskUnreachable();
  addListeningToPhoneCall();
  setTimeout(() => startTour(), 1000);

  window.addEventListener("storage", (event) => {
    if (event.key === "newStatus" && event.newValue) {
      listenStatusChange(event.newValue);
    }

    if (event.key === "currentStatus" && event.newValue) {
      if (
        event.newValue == STATUS_MAPPER.POS_ATENDIMENTO &&
        hasWaitList.value == true
      ) {
        newStatusAfterCall.value === 2
          ? changeStatus(2, "yellow", pauseReason.value)
          : changeStatus(3, "red");
        hasWaitList.value = false;
        pauseReason.value = "";
        newStatusAfterCall.value = "";
      }
    }
  });

  store.commit("setNotifyNewAttendaceOrMenssageChat", false);
  store.commit("setNotifyNewTicket", false);
  if (!store.state.phoneAttendanceData.callerNumber) {
    store.dispatch("timer/startTimer");
  }

  _chatProvider.connection.on("DisconectUser", () => {
    $q.loading.hide();
    localStorage.clear();
    _chatProvider.disconnect();

    $q.dialog({
      title: "Atenção",
      message:
        "Você foi desconectado pois seu usuário está logado em outra sessão.",
      persistent: true,
    }).onOk(() => {
      router.push({ name: "/" });
    });
  });

  _chatProvider.connection.on(
    "EndAttendance",
    (conversationId, message, wrapUpTime) => {
      handleEndAttendance(wrapUpTime);
    }
  );

 
});

onBeforeUnmount(() => {

});
</script>
<style lang="scss" scoped>
@media (max-width: 600px) {
  .chat-interno {
    width: 80%;
  }
}

@media (min-width: 600px) {
  .chat-interno {
    width: 20%;
  }
}

.layout {
  height: 100%;
}

.internal-chat {
  position: absolute;
  bottom: 0px;
  right: 16px;
  z-index: 1;
  // width: 20%;
  height: 67vh;
  background-color: var(--card-form-bg, #ffffff);
  color: var(--card-form-label, inherit);
  border-radius: 14px 14px 0px 0px;
  overflow: hidden;
  box-shadow: 0 -6px 24px rgba(20, 20, 43, 0.18);

  .header {
    height: 7vh;
    border-radius: 0;
    background: linear-gradient(135deg, #312a63 0%, #362f78 55%, #402a6e 100%);

    label {
      font-weight: 600;
      letter-spacing: 0.01em;
    }
  }
}

.btn-internal-chat {
  position: absolute;
  bottom: 20px;
  right: 23px;
  z-index: 1;
  width: 3.2rem;
  height: 3.2rem;
  background: linear-gradient(135deg, #4f46e5, #6d28d9);
  color: white;
  box-shadow: 0 6px 18px rgba(79, 70, 229, 0.4);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 8px 22px rgba(79, 70, 229, 0.5);
    transform: scale(1.05);
  }
}

.btn-internal-notification {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 0.65rem;
  height: 0.65rem;
  min-height: unset;
  min-width: unset;
  padding: 0;
  box-shadow: 0 0 0 2px #ffffff;
  animation: pulseNotification 1.6s ease-in-out infinite;
}

.support-menu {
  border-radius: 16px !important;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35) !important;
  overflow: hidden;
}

.support-menu-list {
  min-width: 250px;
  background: linear-gradient(160deg, #18254c 0%, #312a63 60%, #402a6e 100%);
  padding: 0.6rem 0;
}

.support-menu-section-title {
  padding: 0.6rem 1.1rem 0.3rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #a78bfa;
}

.support-menu-item {
  padding: 0.65rem 1.1rem;
  font-size: 0.92rem;
  font-weight: 700;
  color: #ffffff;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }

  :deep(.q-item__section--avatar) {
    min-width: 0;
    padding-right: 0.7rem;
  }
}

@keyframes pulseNotification {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.3);
  }
}

.content {
  width: 100%;
  position: absolute;
  padding-left: 3.1rem;
  height: 100%;
  background: linear-gradient(
      180deg,
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0)
    ),
    radial-gradient(
      133.17% 32.16% at 59.58% 51.43%,
      rgba(237, 241, 250, 0.24) 0,
      rgba(237, 241, 250, 0.15) 100%
    );
  box-shadow: 4px 0 4px rgb(0 0 0 / 5%);
  backdrop-filter: blur(15px);
}

:global(.card-list-status) {
  border-radius: 14px !important;
  box-shadow: 0 12px 32px rgba(20, 20, 43, 0.18) !important;
  overflow: hidden;
}

.agent-menu-list {
  min-width: 240px;
  padding: 0.4rem 0;
}

.agent-menu-name {
  padding: 0.7rem 1rem 0.5rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #4b5563;
}

.agent-menu-item {
  padding: 0.55rem 1rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e1b4b;
  border-radius: 8px;
  margin: 0 0.4rem;
  width: calc(100% - 0.8rem);
  transition: background 0.15s ease;

  label {
    color: inherit;
  }

  &:hover {
    background: #f3f0ff;
  }

  :deep(.q-item__section--avatar) {
    min-width: 0;
    padding-right: 0.6rem;
  }
}

.agent-menu-dot {
  width: 0.55rem;
  height: 0.55rem;
}

.agent-menu-separator {
  margin: 0.4rem 0.8rem;
  background: rgba(0, 0, 0, 0.1);
}

body.body--dark .agent-menu-name {
  color: #c7c2da !important;
}

body.body--dark .agent-menu-item {
  color: #f5f3fb !important;

  &:hover {
    background: rgba(183, 157, 255, 0.18) !important;
  }
}

body.body--dark .agent-menu-separator {
  background: rgba(183, 157, 255, 0.28) !important;
}

body.body--dark .internal-chat {
  --card-form-bg: #1c1830;
  --card-form-label: #e5e2ef;
}

.avatar-status-btn {
  box-shadow: none !important;

  &:before {
    box-shadow: none !important;
  }

  :deep(.q-focus-helper) {
    display: none !important;
  }

  &:hover,
  &:focus {
    background: transparent !important;
  }

  :deep(.q-img) {
    border-radius: 50%;
    transition: filter 0.15s ease, box-shadow 0.15s ease;
  }

  &:hover :deep(.q-img) {
    filter: brightness(1.15);
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.35);
  }
}

.sidebar {
  background: linear-gradient(103.23deg, #111930 11.08%, #18254c 92.08%);
  height: 100vh;
  width: 50px;
  z-index: 1;
  display: flex;
  flex-direction: column;

  .header {
    flex-shrink: 0;
  }

  .body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;

    .body-menu-item {
      border-bottom: #cecece5c solid 1px;
    }
  }

  .footer {
    flex-shrink: 0;
    padding-bottom: 0.5rem;
  }

  .btn-pause {
    size: 20px;
  }
}
</style>

<style lang="scss">
.arrival-toast-notify {
  min-width: 320px;
  max-width: 400px;
  min-height: 140px;
  border-radius: 12px !important;
  box-shadow: 0 8px 26px rgba(76, 29, 149, 0.35) !important;
  border: 1px solid #7c3aed;
  padding: 1.5rem 1.4rem !important;
  background: #111930 !important;

  .q-notification__message {
    font-size: 1rem;
    font-weight: 700;
    color: #ffffff;
  }

  .q-notification__caption {
    font-size: 0.85rem;
    color: #e9e4fc;
    margin-top: 0.3rem;
  }

  .q-notification__icon {
    font-size: 1.6rem;
    color: #ffffff !important;
  }
}

.arrival-toast-notify.sla-toast-notify {
  width: 400px;
  height: 140px;

  .q-notification__message {
    min-width: 0;
    overflow: hidden;
  }

  .q-notification__message > div:first-child,
  .q-notification__caption {
    overflow: hidden;
  }

  .q-notification__message > div:first-child {
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .q-notification__caption {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
}
</style>
